// extracted by mini-css-extract-plugin
export default {"checkboxLabel":"SigmaPanel_checkboxLabel__B3SN7","checkbox":"SigmaPanel_checkbox__Qn1MR","buttons":"SigmaPanel_buttons__faZ49"};